export enum UserPermissionKind {
	KsefConfiguration = "KsefConfiguration",
	SendDocumentsToKsef = "SendDocumentsToKsef",
	ReceiveDocumentsFromKsef = "ReceiveDocumentsFromKsef",
	PermissionsConfiguration = "PermissionsConfiguration"
}
